"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRefinementToggle = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*
 * Copyright (c) 2022, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
/**
 * Hook for handling the UI state of refinements
 */
const useRefinementToggle = () => {
  const [state, setState] = (0, _react.useState)({
    selectedRefinements: undefined
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    /**
     * Manages an array of selected refinements for the UI to use for instant feedback
     *
     * @param {string} value
     * @param {boolean} selected
     */
    applyUIFeedback(value, selected) {
      if (!selected) {
        const updatedSelectedRefinements = state.selectedRefinements || [];
        // @ts-ignore
        updatedSelectedRefinements.push(value.value);
        // @ts-ignore
        setState({
          selectedRefinements: updatedSelectedRefinements
        });
      } else {
        // @ts-ignore
        const updatedSelectedRefinements = state.selectedRefinements.filter(
        // @ts-ignore
        item => item !== value.value);
        setState({
          selectedRefinements: updatedSelectedRefinements
        });
      }
    },
    /**
     * Updates the state when the selected refinements are updated
     *
     * @param {array} refinements
     */
    setSelectedRefinements(refinements) {
      // @ts-ignore
      setState({
        selectedRefinements: refinements
      });
    }
  });
};
exports.useRefinementToggle = useRefinementToggle;